import React, { useCallback, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MdaeDataGrid, {
  IMdaeDataGridProps,
} from "../../common_components/common_widgets/data-grid";
import { getDataGridActionEllipsisComponent } from "../../common_components/common_widgets/data-grid-action-ellipsis";
import "./index.scss";
import $ from "jquery";
import { actions, callOperation } from "async-ops";
import { useEffect } from "react";
import MdaeActionPopover from "../../common_components/common_widgets/menu-action-popover";
import MdaeButton from "../../common_components/common_widgets/button";
import { cloneDeep, first, isEqual } from "lodash";
import {
  HIDE_LOADER,
  SHOW_LOADER,
  TOGGLE_CONFIRMATION_POPUP,
  TOGGLE_NOTIFY_POPUP,
} from "../../common_components/mdae-common-reducer";
import MdaeCheckBox from "../../common_components/common_widgets/check-box";
import {
  SET_USER_TASK_GRID_CHECKBOXES,
  TOGGLE_USER_TASK_LIST_POPOVER,
  TOGGLE_USER_TASK_SELECT_ALL_FLAG,
  SET_CURRENT_USER_ACTION_MODE,
  TOGGLE_ADD_USER_TASK_POPUP,
  TOGGLE_BULK_EDIT_USER_TASK_POPUP,
  SET_USER_TASK_CHART_DATASOURCE,
  TOGGLE_FILTER_VALUE,
  RESET_ADD_NEW_TASK_POPUP_VALIDATION,
  SET_CURRENT_ATTACHED_LEVEL_DATA,
  SET_USER_TASK_POPUP_MODE,
  SET_USER_TASK_FORM_DATA,
  defaultUserTaskFormData,
  SET_INCLUDE_NON_LEVELCHECKBOX_VALUE,
  TOGGLE_COMPLETE_TASK_TOAST,
  SET_GRID_COMPLETE_CHECKBOX_CLICKED,
  SET_USER_TASK_POPUP_OPENED_FROM_CARD_VIEW,
  SET_TASK_LIST_GRID_SETTING,
  SET_SELECTED_BULK_TASK_ASSIGNED_TO_GROUP,
  SET_USER_TASK_SELECTED_COUNT,
  SET_ASSIGNED_USER_TYPE,
} from "./reducers/user-task-list-reducer";
import { userTaskGridSelection as defaultUserTaskGridSelection } from "./reducers/user-task-list-reducer";
import { GET_USER_TASK_LIST } from "./services/get-user-task-list";
import { bindActionCreators } from "redux";
import AddUserTaskPopup, {
  getTaskItem,
  isMaintenanceTask,
  openUserTaskInEditMode,
  TASK_DISPLAY_MODES,
  TaskDisplayMode,
} from "./add-user-task";
import BulkEditUserTaskPopup, {
  openBulkEditUserTasksPopup,
  openReassignUserTasksPopup,
} from "./bulk-edit-user-task";
import { GET_USER_TASK_STATUS_LIST } from "./services/get-user-task-status-list";
import { GET_AUDITOR_LIST } from "./services/get-auditor-list";
import { GET_ATTACHMENT_LEVEL_LIST } from "./services/get-attachment-level-list";
import { DELETE_USER_TASK } from "./services/delete-user-task";

import UserTaskChart, { getMytasksDataFromLocalStorageOrDefault } from "./user-task-charts";
import { QUICK_COMPLETE_USER_TASK } from "./services/quick-complete-user-task";
import mdaeNotify, {
  NOTIFY_MESSAGE_TYPE,
} from "../common_widgets/toast/notify";
import { SET_MY_TASK_WIDGET_DATASOURCE_FROM_TASK_LIST } from "../user-task-card-view/reducers/user-task-card-view-reducer";
import MdaeAddButton from "../common_widgets/add-button";
import { GET_USER_TASK_LIST_BY_LEVEL } from "./services/get-user-task-list-by-level";
import {
  FG_ALL_AUDIT_VIEWER,
  FG_AUDIT_A_CASE,
  FG_AUDIT_PROPERTY_EDITING,
  FG_AUDIT_VIEWER,
  FG_QA_REVIEW_OR_TASK_MANAGER,
  hasAnyFeatureGroupAccess,
} from "../user-permissions-helper";
import { GET_USER_TASK_DATASOURCE } from "./services/get-user-task-datasource";
import { NOTIFY_POPUP_TYPES } from "../common_widgets/notify-popup";
import { SET_USER_TASK_GRID_FILTER } from "../../pages/external-audit/reducers/external-audit-reducer";
import { GET_COMPLETED_AND_CANCELED_MY_TASKS } from "../../pages/my-tasks/services/get-completed-and-canceled-my-tasks";
import { GET_MY_TASK_LIST } from "../user-task-card-view/services/get-my-task-list";
import { MY_TASK_PAGE_TABS } from "../../pages/my-tasks/constant";
import { GET_ACTIVE_USERS_LIST } from "./services/get-active-users-list";
import CheckBox from "devextreme/ui/check_box";
import { format } from "date-fns";
import {
  SET_IS_INCOMPLETE_TASK_COUNT_CLICK,
  UPDATE_CASE_DETAIL_LIST_DATA,
} from "../../pages/external-audit/case-list/reducers/case-list-reducer";
import { GET_ACTIVE_EXTERNAL_USER_LIST_FOR_USER_GROUP } from "../../pages/user-management/external-users/services/get-active-external-user-list-for-user-group";
import CancelUpdatedTaskToast from "../cancel-updated-task/cancel-updated-task-toast";
import {
  TASK_HQ_PAGE_DATAGRID_STATE_STORAGE_KEYS,
  USER_TYPE,
} from "./constant";
import { GET_EXTERNAL_USER_GROUP_LIST } from "../../pages/user-management/external-users/services/get-external-user-group-list";
import { GET_TASK_GROUP_LIST } from "../../pages/user-management/task-groups/services/get-task-group-list";
import { IColumnProps } from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import dxDataGrid from "devextreme/ui/data_grid";
import { toggleCaseDetailPopup } from "../../pages/external-audit/case-detail/case-detail-common-functions";
import { GET_EA_CASE } from "../../pages/external-audit/case-detail/services/get-audit-case-finding-status";
import { CASE_DETAIL_POPUP_MODES } from "../../pages/external-audit/case-detail/component";
export const USER_TASK_POPUP_MODE = {
  ADD: "ADD",
  EDIT: "EDIT",
};
export const BULK_EDIT_USER_TASK_POPUP_MODE = {
  BULK_EDIT: "BULK_EDIT",
  REASSIGN: "REASSIGN",
};
export const resetAddTaskPopupValidation = (dispatch) => {
  dispatch({
    type: RESET_ADD_NEW_TASK_POPUP_VALIDATION,
    data: {
      isAddNewTaskFormDataValid: true,
    },
  });
};
export const quickCompleteTask = (
  dispatch,
  cellData,
  refreshUserTaskListFunction,
  isManagerView,
  currentAttachedLevelId,
  currentAttachedLevelName,
  isExternalUser,
  initialTaskData,
  isCancelUpdatedTask
) => {
  dispatch({ type: SHOW_LOADER });
  const currentRowData = cellData;
  const task = {
    completionDate: isCancelUpdatedTask ? null : new Date(),
    userTaskId: currentRowData.userTaskId,
    refTaskId: currentRowData.refTaskId,
    attachedLevelId: currentRowData.attachedLevelId,
    attachedLevel: currentRowData.attachedLevel,
    auditId: currentRowData.auditId,
    assignedToUserId: isCancelUpdatedTask
      ? initialTaskData?.assignedToUserId
      : currentRowData.assignedToUserId,
    assignedUserType: currentRowData.assignedUserType,
    isSavedFromExternalUser: isExternalUser ? true : false,
    refTaskName: currentRowData.refTaskName,
    statusId: isCancelUpdatedTask ? initialTaskData?.statusId : 0,
    notificationId: initialTaskData?.notificationId ? initialTaskData?.notificationId : currentRowData.notificationId,
    newUserTasksCreatedIds: initialTaskData?.newUserTasksCreatedIds,
    isCancelUpdatedTask: isCancelUpdatedTask,
    dueDate:currentRowData.dueDate
  };
  callOperation(QUICK_COMPLETE_USER_TASK, task).then(function(response) {
    dispatch({ type: HIDE_LOADER });
    if (response.isUpdated) {
      if (typeof refreshUserTaskListFunction === "function")
        refreshUserTaskListFunction();
      else if (!isManagerView) {
        dispatch(
          actions.asyncOperationStart(GET_USER_TASK_LIST_BY_LEVEL, {
            attachedLevelId: currentAttachedLevelId,
            attachedLevelName: currentAttachedLevelName,
            includeNonAttachedLevelTasks: false,
          })
        );
      } 
      if (!isExternalUser) {
        mdaeNotify({
          message: currentRowData.refTaskName + " - task updated successfully.",
          messageType: NOTIFY_MESSAGE_TYPE.SUCCESS,
        });
      } else {
        if (!isCancelUpdatedTask)
          dispatch({
            type: TOGGLE_COMPLETE_TASK_TOAST,
            data: {
              isCompleteTaskToastVisible: true,
            },
          });
      }
    }
    let assignedToExternalUser = [];
    let newTaskCreated = [];

    if (response.newUserTasks && response.newUserTasks.length > 0) {
      for (var item of response.newUserTasks) {
        if (item.userTaskId) {
          response.newUserTasksCreated.push(item);
        }
      }
    }

    if (isExternalUser && response.newUserTasksCreated?.length > 0) {
      assignedToExternalUser = response.newUserTasksCreated.filter(
        (x) => x.assignedToUserId == currentRowData.assignedToUserId
      );
      newTaskCreated = assignedToExternalUser;
    } else {
      newTaskCreated = response.newUserTasksCreated;
    }
    if (newTaskCreated && newTaskCreated.length > 0) {
      var displayMessage = "";
      var arrayOfTaskItem = [];
      for (var item of newTaskCreated) {
        displayMessage =
          " " +
          item.refTaskName +
          ", " +
          "Assigned To: " +
          item.assignedToUserName +
          ", Due " +
          new Date(item.dueDate)?.toLocaleDateString();
        arrayOfTaskItem.push(displayMessage);
      }
      dispatch({
        type: TOGGLE_NOTIFY_POPUP,
        data: {
          visible: true,
          contentHtml: () => {
            return (
              <div>
                <div style={{ display: "block" }}>
                  New task(s) were created as a result of updating this task and
                  have been configured based on the process template.{" "}
                </div>
                <div>
                  <ul>{getTaskItem(arrayOfTaskItem)}</ul>
                </div>
              </div>
            );
          },
          notifyPopupType: NOTIFY_POPUP_TYPES.ALERT,
          closeButtonText: "OK",
          width: 470,
          height: "auto",
        },
      });
    }
    dispatch({
      type: SET_USER_TASK_FORM_DATA,
      data: {
        initialTaskData: {
          ...initialTaskData,
          notificationId: response.notificationId,
          newUserTasksCreatedIds: response.newUserTasksCreated?.map(
            (x) => x.userTaskId
          ),
        },
      },
    });
  });
};
export const setIsGridSettingCalled = (dispatch, isGridSettingCalled) => {
  dispatch({
    type: SET_TASK_LIST_GRID_SETTING,
    data: {
      isGetGridSettingCalled: isGridSettingCalled,
    },
  });
};

const deleteMessage =
  "Deleting a task cannot be undone. Do you want to continue?";
const USER_ACTION_MODE = Object.freeze({
  MULTIPLE_SELECT: "MULTIPLE_SELECT",
  MY_TASK_DELETE_MULTIPLE_SELECT: "MY_TASK_DELETE_MULTIPLE_SELECT",
  MY_TASK_EDIT_MULTIPLE_SELECT: "MY_TASK_EDIT_MULTIPLE_SELECT",
});
export const toggleUserTaskPopup = (dispatch, isVisible, title, mode) => {
  dispatch({
    type: TOGGLE_ADD_USER_TASK_POPUP,
    data: {
      userTaskPopupMode: mode,
      userTaskPopupTitle: title,
      isAddUserTaskPopupVisible: isVisible,
      userTaskFormData:{...defaultUserTaskFormData} //when next time the popup open it should not call the doc api of previous taskid
    },
  });
};
interface IUserTaskListProps {
  isUserTaskChartVisible?: boolean;
  isUserTaskBulkOptionVisible?: boolean;
  excelExportFileName?: string;
  myTaskWidgetId?: any;
  attachedLevelId?: number;
  attachedLevelName?: string;
  includeNonAttachedLevelTasks?: boolean;
  auditGroupId?: number;
  isManagerView?: boolean;
  refreshUserTaskListFunction?: () => void;
  userTaskListStateStoringKey?: string;
  isFromMyTaskPage?: boolean;
  myTasksPageOptions?: {
    myTasksPageTabName: string;
  };
  searchText?: string;
  setSearchText?: (searchText: string) => void;
  userTaskListDataSource?: any[];
  isFromAuditView?: boolean;
  attachedLevelTitleName?: string;
  doNotLoadDatasourcesInd?: boolean;
  isUserTaskListGridSetFiltered?: boolean;
  isExternalUser?: boolean;
  isToolBarNotVisible?:boolean;
  caseData?: {
    eaCaseId: string | number;
    [key: string]: any;
  }
}

const UserTaskList: React.FC<IUserTaskListProps> = (props) => {
  let taskDataPrefix = "";
  if(props?.caseData?.eaCaseId)
    taskDataPrefix = props.caseData?.eaCaseId?.toString()
  const dispatch = useDispatch();

  const [userTaskDataGridInstance, setUserTaskListGridInstance] = useState<dxDataGrid | null>(null);
  const onUserTaskListGridInstance = (e) => {
    setUserTaskListGridInstance(e.component);
  };
  const getCurrentSelectedRowData: any = () => {
    return first(userTaskDataGridInstance?.getSelectedRowsData());
  };
  var isGetGridSettingCalled = useSelector(
    (state) => state["userTaskListReducer"].isGetGridSettingCalled,
    isEqual
  );
  const getSelectedItemsCount = () => {
    const selectedRowsData = userTaskDataGridInstance.getSelectedRowsData();
    return selectedRowsData.length;
  };
  const completedOrCanceledTasksData =  useSelector(
    (state) => state["userTaskListReducer"].completedAndCanceledTabData,
    isEqual);
  const bulkTaskDeleteMessage = () => {
    const bulkDeleteMessage =
      "You are about to delete " +
      getSelectedItemsCount() +
      " tasks. This action cannot be undone. Do you want to continue?";
    return bulkDeleteMessage;
  };
  const currentUserId: any = useSelector(
    (state) => state["userTaskListReducer"].currentUserId,
    isEqual
  );
  const userTaskGridSelection = useSelector(
    (state) => state["userTaskListReducer"].userTaskGridSelection.mode,
    isEqual
  );
  const currentUserActionMode = useSelector(
    (state) => state["userTaskListReducer"].currentUserActionMode,
    isEqual
  );
  const userTaskPopupMode = useSelector(
    (state: any) => state["userTaskListReducer"].userTaskPopupMode,
    isEqual
  );
  const defaultStatusValue = useSelector(
    (state: any) => state["userTaskListReducer"].defaultStatusValue,
    isEqual
  );
  const includeNonAttachedLevelTasks = useSelector(
    (state: any) => state["userTaskListReducer"].includeNonAttachedLevelTasks,
    isEqual
  );
  const userTaskChartSelectedIndex = useSelector(
    (state: any) => state["userTaskListReducer"].userTaskChartSelectedIndex,
    isEqual
  );
  const userTaskListDataGridFilter = useSelector(
    (state: any) => state["userTaskListReducer"].userTaskListDataGridFilter,
    isEqual
  );
  const isFilterValueChange = useSelector(
    (state: any) => state["userTaskListReducer"].isFilterValueChange,
    isEqual
  );
  const assignedToUserList = useSelector(
    (state: any) => state["userTaskListReducer"].assignedToUserList,
    isEqual
  );
  const currentUser = useSelector(
    (state) => state["mdaeNavigationBarReducer"].currentUser,
    isEqual
  );
  const hasAuditViewAccess = useMemo(
    () =>
      hasAnyFeatureGroupAccess(
        [FG_AUDIT_A_CASE, FG_AUDIT_VIEWER, FG_ALL_AUDIT_VIEWER],
        currentUser
      ),
    [currentUser]
  );
  const isDocumentManagementEnabled = useSelector(
    (state) => state["documentManagementReducer"].isDocumentManagementEnabled,
    isEqual
  );
  const hasEditAccess = useMemo(
    () =>
      hasAnyFeatureGroupAccess([FG_AUDIT_PROPERTY_EDITING], currentUser) ||
      currentUser?.isTaskHQAccessEnabled,
    [currentUser]
  );
  const hasBulkEditAccess = useMemo(
    () => hasAnyFeatureGroupAccess([FG_AUDIT_PROPERTY_EDITING], currentUser),
    [currentUser]
  );
  const hasTaskManagerAccess = useMemo(
    () => hasAnyFeatureGroupAccess([FG_QA_REVIEW_OR_TASK_MANAGER], currentUser),
    [currentUser]
  );
  const isUserTaskListGridSetFiltered = useSelector(
    (state) => state["externalAuditReducer"].isUserTaskListGridSetFiltered,
    isEqual
  );
  const isInCompleteTaskCountClick = useSelector(
    (state) => state["caseListReducer"].isInCompleteTaskCountClick,
    isEqual
  );
  const userTaskStatusList = useSelector(
    (state: any) => state["userTaskListReducer"].userTaskStatusList,
    isEqual
  );
  const isCompleteTaskToastVisible = useSelector(
    (state: any) => state["userTaskListReducer"].isCompleteTaskToastVisible,
    isEqual
  );
  const userTaskFormData = useSelector(
    (state: any) => state["userTaskListReducer"].userTaskFormData,
    isEqual
  );
  const attachLevelEnums = useSelector(
    (state: any) => state["userTaskListReducer"].attachLevelEnums,
    isEqual
  );
  let userLevelNameList = useSelector(
    (state) => state["userTaskListReducer"].userLevelNameList,
    isEqual
  );
  const isCaseDetailPopupVisible = useSelector(
    (state: any) => state["caseDetailReducer"].isCaseDetailPopupVisible,
  );
  const openTaskTabFromUrl = (e) => {
    const openTaskTab = (userTaskId) => {
      if (userTaskId && userTaskId > 0) {
        e.component.byKey(userTaskId).then((data) => {
          onUserTaskEditClick(data, 0);
        });
      }
    };
    let queryParams = new URLSearchParams(window.location.search);
    if (queryParams.has("reassignedtaskid") && e.component.getDataSource()) {
      openTaskTab(parseInt(queryParams.get("reassignedtaskid")));
      if (queryParams.has("reassignedtaskid")) {
        queryParams.delete("reassignedtaskid");
        let url = window.location.href;
        window.history.replaceState(null, "", url.split("&")[0]);
      }
    }
  };
  if (userLevelNameList && userLevelNameList.length > 0) {
    if (
      props.attachedLevelName?.toUpperCase() === "EA" &&
      userTaskFormData?.level?.toUpperCase() === "EAC" &&
      userTaskPopupMode == USER_TASK_POPUP_MODE.ADD
    ) {
      const isAllExists =
        userLevelNameList.filter((x) => x.attachedLevelId === -1).length > 0;
      if (!isAllExists) {
        userLevelNameList.unshift({
          attachedLevelId: -1,
          attachedLevelTitle: "Add tasks to all cases in round",
        });
      }
    } else {
      userLevelNameList = userLevelNameList.filter(
        (x) => x.attachedLevelId > 0
      );
    }
  }

  const toggleUserTaskListActionPopover = (isVisible, target) => {
    dispatch({
      type: TOGGLE_USER_TASK_LIST_POPOVER,
      data: {
        ["userTaskListDataGridActionPopoverTarget" +  (taskDataPrefix ?? "")]: target,
        ["isUserTaskListDataGridActionPopoverVisible" +  (taskDataPrefix ?? "")]: isVisible,
      },
    });
    if (isVisible && isCompleteTaskToastVisible) {
      dispatch({
        type: TOGGLE_COMPLETE_TASK_TOAST,
        data: {
          isCompleteTaskToastVisible: false,
        },
      });
    }
  };
  const shouldShowEditInCase = () => {
    const selectedRowData = getCurrentSelectedRowData();
    return (
      (hasEditAccess || hasTaskManagerAccess) &&
      !props.isFromAuditView &&
      !props.isExternalUser &&
      selectedRowData?.attachedLevel === "EAC" &&
      selectedRowData?.isAccessToAuditCaseDetailEnabled
    );
  };

  const hasDeleteAccess = () => {
    if (
      (!hasEditAccess && !hasTaskManagerAccess) ||
      getCurrentSelectedRowData()?.completeInd
    ) {
      return false;
    } else if (hasTaskManagerAccess) {
      return true;
    } else if (
      !getCurrentSelectedRowData()?.requiredForAuditCompletionInd &&
      hasEditAccess &&
      !currentUser?.isTaskHQAccessEnabled
    ) {
      return true;
    }
    return false;
  };
  const actionPopoverMenuList = () => [
    {
      text: "Documents",
      visible: isDocumentManagementEnabled,
      icon: () => {
        return <div style={{ height: "14px" }} className={"upload-icon"}></div>;
      },
      onClick: (e) => {
        onUserTaskEditClick(getCurrentSelectedRowData(), 1);
        toggleUserTaskListActionPopover(false, null);
      },
    },
    {
      text: hasEditAccess ? "Edit" : "Preview",
      className: "edit",
      icon: () => {
        return (
          <div
            style={{ height: "14px" }}
            className={
              hasEditAccess ? "edit-action-icon" : "preview-action-icon"
            }
          ></div>
        );
      },
      onClick: () => {
        onUserTaskEditClick(getCurrentSelectedRowData(), 0);
        toggleUserTaskListActionPopover(false, null);
      },
    },
     {
      text: "Open in Case",
      className: "edit",
      visible: shouldShowEditInCase(),
      icon: () => {
        return (
          <div
            style={{ height: "14px" }}
            className={
              "green-arrow-right-icon" 
            }
          ></div>
        );
      },
      onClick: () => {
        const selectedRowData = getCurrentSelectedRowData();
        const preTaskOpenPromises = [];
        preTaskOpenPromises.push(
          onUserTaskEditClick(
            selectedRowData,
            0,
            TASK_DISPLAY_MODES.CASE_POPUP,
          ),
        );
        preTaskOpenPromises.push(
          callOperation(GET_EA_CASE, selectedRowData.linkedCaseId),
        );
        Promise.all(preTaskOpenPromises).then(([_, caseData]) => {
          toggleCaseDetailPopup(
            dispatch,
            true,
            "Audit Case Details",
            { ...caseData, mode: CASE_DETAIL_POPUP_MODES.VIEW_WITH_TASK, userTaskId: selectedRowData.userTaskId },
            0,
          );
        });
        toggleUserTaskListActionPopover(false, null);
      },
    },
    {
      text: "Delete",
      visible: hasDeleteAccess(),
      icon: () => {
        return (
          <div
            style={{ height: "16px" }}
            className={"delete-action-icon"}
          ></div>
        );
      },
      onClick: () => {
        toggleConfirmationPopupVisible(true, deleteMessage);
      },
    },
  ];
  const onUserTaskEditClick = (selectedRowData, userTaskSelectedIndex, displayMode: TaskDisplayMode = TASK_DISPLAY_MODES.TASK_POPUP) => {
    return openUserTaskInEditMode(
      selectedRowData,
      toggleUserTaskPopup,
      userTaskSelectedIndex,
      dispatch,
      true,
      false,
      displayMode
    );
  };
  
  const refreshTaskHqUserTaskListFunction = useCallback(() => {
    if (userTaskDataGridInstance && typeof userTaskDataGridInstance.refresh === "function") {
      userTaskDataGridInstance.refresh();
      userTaskDataGridInstance.clearSelection();
    }
  }, [userTaskDataGridInstance]);

  function containsUserTaskIdFilter(filter) {
    if (!filter) return false;
    if (Array.isArray(filter) && typeof filter[0] === 'string') {
      return filter[0] === 'userTaskId';
    }
    if (Array.isArray(filter)) {
      return filter.some((item) => containsUserTaskIdFilter(item));
    }
    return false;
  }
  
  const taskHqDataSource = useMemo(
    () =>
      new CustomStore({
        key: "userTaskId",
        load: async function(loadOptions) {
          try {
            if (containsUserTaskIdFilter(loadOptions.filter) || (!loadOptions.filter && loadOptions.select)) {
              return { data: [], totalCount: 0 }; 
            }
            const userData = {userTaskChartSelectedIndex,...getMytasksDataFromLocalStorageOrDefault()}
            const result = await callOperation((GET_USER_TASK_LIST), {...loadOptions,userData} );
            if (result.groupedData) return { data: result.groupedData };
            else if(result.data){
              dispatch({
                type: SET_USER_TASK_CHART_DATASOURCE,
                data: { userTaskChartDataSource: result.chartData },
              });
              return {data:result.data,totalCount:result.totalCount};
            } 
            else {
              return {data: [],totalCount: 0,};
            }
          } catch (error) {
            dispatch({
              type: SET_USER_TASK_CHART_DATASOURCE,
              data: { userTaskChartDataSource: {} },
            });
            return {
              data: [],
              totalCount: 0,
            };
          }
        },
      }),
    [userTaskChartSelectedIndex,completedOrCanceledTasksData]
  );
  
  const userTaskListDataGridOptions = useMemo(() => {
    return getUserTaskListDataGridOptions(
      toggleUserTaskListActionPopover,
      onUserTaskListGridInstance,
      currentUserId,
      onUserTaskEditClick,
      callOperation,
      dispatch,
      props.isUserTaskChartVisible,
      isFilterValueChange,
      userTaskChartSelectedIndex,
      props.excelExportFileName,
      props.myTaskWidgetId,
      props.attachedLevelName,
      props.attachedLevelId,
      props.isManagerView,
      props.isFromMyTaskPage,
      props.myTasksPageOptions,
      props.setSearchText,
      props.userTaskListStateStoringKey,
      props.isManagerView ? refreshTaskHqUserTaskListFunction :props.refreshUserTaskListFunction,
      props.userTaskListDataSource,
      isUserTaskListGridSetFiltered,
      currentUserActionMode,
      isInCompleteTaskCountClick,
      userTaskStatusList,
      props.isExternalUser,
      isCompleteTaskToastVisible,
      openTaskTabFromUrl,
      attachLevelEnums,
      isMaintenanceTask,
      isGetGridSettingCalled,
      TASK_HQ_PAGE_DATAGRID_STATE_STORAGE_KEYS,
      hasAuditViewAccess,
      props.isToolBarNotVisible,
      taskDataPrefix,
      props.attachedLevelId,
      taskHqDataSource
    );
  }, [
    userTaskChartSelectedIndex,
    currentUserId,
    isUserTaskListGridSetFiltered,
    props.attachedLevelId,
    first(props.userTaskListDataSource)?.version,
    currentUserActionMode,
    isInCompleteTaskCountClick,
    isCompleteTaskToastVisible,
    isGetGridSettingCalled,
    hasAuditViewAccess,
  ]);
  const asyncAction = bindActionCreators(
    {
      asyncOperationStart: actions.asyncOperationStart,
    },
    dispatch
  );
  useEffect(() => {
    if (props.attachedLevelId && props.attachedLevelName) {
      asyncAction.asyncOperationStart(GET_USER_TASK_LIST_BY_LEVEL, {
        attachedLevelId: props.attachedLevelId,
        attachedLevelName: props.attachedLevelName,
        includeNonAttachedLevelTasks: false,
        taskDataPrefix
      });
    }
    if (!props.doNotLoadDatasourcesInd) {
      asyncAction.asyncOperationStart(GET_ATTACHMENT_LEVEL_LIST, {});
      asyncAction.asyncOperationStart(GET_USER_TASK_STATUS_LIST, {});
      asyncAction.asyncOperationStart(GET_AUDITOR_LIST, {});
      if (!assignedToUserList || assignedToUserList?.length === 0)
        asyncAction.asyncOperationStart(GET_ACTIVE_USERS_LIST, {});
      asyncAction.asyncOperationStart(
        GET_ACTIVE_EXTERNAL_USER_LIST_FOR_USER_GROUP,
        {}
      );
      asyncAction.asyncOperationStart(GET_EXTERNAL_USER_GROUP_LIST, {});
      asyncAction.asyncOperationStart(GET_TASK_GROUP_LIST, {});
    }
  }, [props.attachedLevelId, props.attachedLevelName, props.isManagerView]);
  useEffect(() => {
    dispatch({
      type: TOGGLE_FILTER_VALUE,
      data: { isFilterValueChange: true },
    });
  }, [userTaskListDataGridFilter]);
  useEffect(() => {
    if (userTaskDataGridInstance && props.searchText !== undefined)
      userTaskDataGridInstance.searchByText(props.searchText);
  }, [props.searchText]);
  useEffect(() => {
    dispatch({
      type: SET_CURRENT_USER_ACTION_MODE,
      currentUserActionMode: "",
    });
  }, []);
  const toggleUserTaskGridCheckboxes = (_currentUserActionMode = "") => {
    userTaskDataGridInstance.beginUpdate();
    if (userTaskGridSelection === "multiple") {
      userTaskDataGridInstance.columnOption("userTaskId", "visible", true);
      userTaskDataGridInstance.columnOption("completeInd", "visible", true);
      dispatch({
        type: SET_USER_TASK_GRID_CHECKBOXES,
        data: {
          userTaskGridSelection: {
            ...defaultUserTaskGridSelection,
            mode: "single",
          },
        },
      });
      dispatch({
        type: SET_CURRENT_USER_ACTION_MODE,
        currentUserActionMode: "",
      });
      dispatch({
        type: TOGGLE_USER_TASK_SELECT_ALL_FLAG,
        isUserTaskSelectAllCheckBoxClicked: false,
      });
      userTaskDataGridInstance.clearSelection();
    } else {
      userTaskDataGridInstance.columnOption("userTaskId", "visible", false);
      userTaskDataGridInstance.columnOption("completeInd", "visible", false);
      if (props.isFromMyTaskPage) userTaskDataGridInstance.clearSelection();
      dispatch({
        type: SET_USER_TASK_GRID_CHECKBOXES,
        data: {
          userTaskGridSelection: {
            ...defaultUserTaskGridSelection,
            mode: "multiple",
          },
        },
      });
      dispatch({
        type: SET_CURRENT_USER_ACTION_MODE,
        currentUserActionMode: _currentUserActionMode,
      });
    }
    userTaskDataGridInstance.endUpdate();
  };
  const toggleUserTaskGridCheckboxesForMyTask = (
    _currentUserActionMode = ""
  ) => {
    if (props.isFromMyTaskPage)
      toggleUserTaskGridCheckboxes(_currentUserActionMode);
  };
  const toggleConfirmationPopupVisible = (isVisible, message) => {
    if (isVisible) {
      showConfirmationPopup(message);
    } else {
      hideConfirmationPopup();
    }
  };
  const showConfirmationPopup = (message) => {
    dispatch({
      type: TOGGLE_CONFIRMATION_POPUP,
      data: {
        onConfirm: () => {
          deleteSelectedTask();
          toggleUserTaskGridCheckboxesForMyTask();
        },
        visible: true,
        confirmShown: true,
        declineShown: true,
        width: 380,
        height: 200,
        title: "Confirmation",
        contentHtml: message,
        onDecline: () => {
          hideConfirmationPopup();
          toggleUserTaskGridCheckboxesForMyTask();
        },
      },
    });
  };
const hideConfirmationPopup = useCallback(() => {
  dispatch({
    type: TOGGLE_CONFIRMATION_POPUP,
    data: {
      visible: false,
    },
  });
  toggleUserTaskListActionPopover(false, null);
}, [dispatch, toggleUserTaskListActionPopover]);

  const showNoRowsSelectedWarning = useCallback(() => {
    dispatch({
      type: TOGGLE_CONFIRMATION_POPUP,
      data: {
        onConfirm: hideConfirmationPopup,
        visible: true,
        confirmShown: true,
        declineShown: true,
        width: 380,
        height: 200,
        title: "Warning",
        contentHtml: "Please select at least one task.",
        onDecline: () => {
          hideConfirmationPopup();
          toggleUserTaskGridCheckboxesForMyTask();
        },
      },
    });
  }, [dispatch,hideConfirmationPopup, toggleUserTaskGridCheckboxesForMyTask]);
  
  const showNo2000PlusRowsSelectedWarning = useCallback(() => {
    dispatch({
      type: TOGGLE_CONFIRMATION_POPUP,
      data: {
        onConfirm: hideConfirmationPopup,
        visible: true,
        confirmShown: true,
        declineShown: true,
        width: 380,
        height: 200,
        title: "Warning",
        contentHtml: "Please select task less than 2000.",
        onDecline: () => {
          hideConfirmationPopup();
          toggleUserTaskGridCheckboxesForMyTask();
        },
      },
    });
  }, [dispatch,hideConfirmationPopup, toggleUserTaskGridCheckboxesForMyTask]);
    
  const getUserTaskSelectedIds = (selectedRowsData) => {
    var listItems = selectedRowsData.map((item) => item.userTaskId);
    return listItems;
  };
  const getSelectedRowsData = () => {
    return userTaskDataGridInstance.getSelectedRowsData();
  };
  const deleteSelectedTask = useCallback(() => {
    dispatch({ type: SHOW_LOADER });
    toggleConfirmationPopupVisible(false, "");
    toggleUserTaskListActionPopover(false, null);
  
    const selectedRowsData = userTaskDataGridInstance.getSelectedRowsData();
  
    callOperation(
      DELETE_USER_TASK,
      selectedRowsData && selectedRowsData.length > 0
        ? {
            userTaskIds: getUserTaskSelectedIds(selectedRowsData),
          }
        : {
            userTaskid: getCurrentSelectedRowData().userTaskId,
          }
    ).then((response) => {
      dispatch({ type: HIDE_LOADER });
  
      if (response.isDeleted) {
        if (typeof props.refreshUserTaskListFunction === "function") {
          props.refreshUserTaskListFunction();
        } else if (props.isManagerView) {
          refreshTaskHqUserTaskListFunction();
        } else {
          asyncAction.asyncOperationStart(GET_USER_TASK_LIST_BY_LEVEL, {
            attachedLevelId: props.attachedLevelId,
            attachedLevelName: props.attachedLevelName,
            includeNonAttachedLevelTasks: includeNonAttachedLevelTasks,
            taskDataPrefix,
          });
        }
      }
    });
  }, [
    dispatch,
    userTaskDataGridInstance,
    props.refreshUserTaskListFunction,
    props.isManagerView,
    props.attachedLevelId,
    props.attachedLevelName,
    includeNonAttachedLevelTasks,
    taskDataPrefix,
    refreshTaskHqUserTaskListFunction,
    toggleConfirmationPopupVisible,
    toggleUserTaskListActionPopover,
    getCurrentSelectedRowData,
    getUserTaskSelectedIds
  ]);

  const handleTaskLevelValueChanged = useCallback((e) => {
    if (e.event) {
      asyncAction.asyncOperationStart(GET_USER_TASK_LIST_BY_LEVEL, {
        attachedLevelId: props.attachedLevelId,
        attachedLevelName: props.attachedLevelName,
        includeNonAttachedLevelTasks: e.value,
        taskDataPrefix
      });
  
      dispatch({
        type: SET_INCLUDE_NON_LEVELCHECKBOX_VALUE,
        data: { includeNonAttachedLevelTasks: e.value },
      });
    }
  }, [
    props.attachedLevelId,
    props.attachedLevelName,
    taskDataPrefix,
    dispatch
  ]);
  

  const handleBulkActionsClick = useCallback(() => {
    userTaskDataGridInstance.clearSelection();
    if (userTaskGridSelection === "multiple") {
      toggleUserTaskGridCheckboxes();
    } else {
      toggleUserTaskGridCheckboxes(USER_ACTION_MODE.MULTIPLE_SELECT);
    }
  }, [
    userTaskDataGridInstance,
    userTaskGridSelection,
    toggleUserTaskGridCheckboxes 
  ]);
  

const onClickDeleteMultipleTasks = useCallback(() => {
  const initiateDeleteTask = () => {
    const countOfTask = getSelectedItemsCount();
    if(countOfTask && countOfTask>2000){
      showNo2000PlusRowsSelectedWarning();
    }
    else if (getSelectedItemsCount() > 0) {
      toggleConfirmationPopupVisible(true, bulkTaskDeleteMessage);
    } else if (props.isFromMyTaskPage) {
      showNoRowsSelectedWarning();
    }
  };

  if (props.isFromMyTaskPage) {
    if (currentUserActionMode === USER_ACTION_MODE.MY_TASK_DELETE_MULTIPLE_SELECT) {
      initiateDeleteTask();
    } else {
      toggleUserTaskGridCheckboxes(USER_ACTION_MODE.MY_TASK_DELETE_MULTIPLE_SELECT);
    }
  } else {
    initiateDeleteTask();
  }
}, [
  props.isFromMyTaskPage,
  currentUserActionMode,
  getSelectedItemsCount,
  showNoRowsSelectedWarning,
  toggleConfirmationPopupVisible,
  bulkTaskDeleteMessage,
  toggleUserTaskGridCheckboxes
]);
const toggleBulkEditUserTaskPopup = useCallback((isVisible, title) => {
  dispatch({
    type: TOGGLE_BULK_EDIT_USER_TASK_POPUP,
    data: {
      isBulkEditUserTaskPopupVisible: isVisible,
      userTaskBulkEditPopupTitle: title,
    },
  });
}, [dispatch]);

const onClickBulkTaskEdit = useCallback(() => {
  const initateBulkEditTasks = () => {
    const selectedRowsData = userTaskDataGridInstance.getSelectedRowsData();
    if(selectedRowsData && selectedRowsData.length>2000){
      showNo2000PlusRowsSelectedWarning();
    }
    else if (selectedRowsData && selectedRowsData.length > 0) {
      openBulkEditUserTasksPopup(
        getSelectedRowsData(),
        toggleBulkEditUserTaskPopup,
        dispatch
      );
    } else if (props.isFromMyTaskPage) {
      showNoRowsSelectedWarning();
    }
  };

  if (props.isFromMyTaskPage) {
    if (currentUserActionMode === USER_ACTION_MODE.MY_TASK_EDIT_MULTIPLE_SELECT) {
      initateBulkEditTasks();
    } else {
      toggleUserTaskGridCheckboxes(USER_ACTION_MODE.MY_TASK_EDIT_MULTIPLE_SELECT);
    }
  } else {
    initateBulkEditTasks();
  }
}, [
  props.isFromMyTaskPage,
  currentUserActionMode, 
  userTaskDataGridInstance,
  openBulkEditUserTasksPopup,
  toggleBulkEditUserTaskPopup,
  dispatch,
  showNoRowsSelectedWarning,
  toggleUserTaskGridCheckboxes,
  getSelectedRowsData,
  showNo2000PlusRowsSelectedWarning
]);

const onReassignClick = useCallback(() => {
  const selectedRowsData = userTaskDataGridInstance.getSelectedRowsData();
  if (selectedRowsData && selectedRowsData.length > 2000) {
    showNo2000PlusRowsSelectedWarning();
  }
  else if (selectedRowsData && selectedRowsData.length > 0) {
    openReassignUserTasksPopup(
      getSelectedRowsData(),
      toggleBulkEditUserTaskPopup,
      dispatch
    );
  }
}, [
  userTaskDataGridInstance,
  openReassignUserTasksPopup,
  toggleBulkEditUserTaskPopup,
  dispatch,
  getSelectedRowsData,
  showNo2000PlusRowsSelectedWarning
]);
const TaskSelectionCounter: React.FC = () => {
  const selectedTasksCount = useSelector(
    (state: any) => state.userTaskListReducer.selectedTasksCount
  );

  const isOverLimit = selectedTasksCount > 2000;

  return (
    <label
      style={{
        color: isOverLimit ? "red" : "green",
        padding: "10px 10px 0 0",
      }}
    >
      {selectedTasksCount} of 2000 Tasks selected
    </label>
  );
};
  const renderToolbarButtonTemplate = () => {
    return (
      <div style={{ display: "flex" }}>
        <MdaeCheckBox
          id="chkShowNonLevelTasks"
          text={"Include non-case level tasks"}
          style={{ paddingTop: "5px" }}
          visible={!props.isManagerView && props.attachedLevelName == "EAC"}
          value={Boolean(includeNonAttachedLevelTasks)}
          onValueChanged={handleTaskLevelValueChanged}
        ></MdaeCheckBox>
        {!props.isFromMyTaskPage && (
          <>
            <MdaeAddButton
              id={"btnAddNewTask"}
              title={"Add New Task"}
              visible={Boolean(hasEditAccess && !props.isManagerView)}
              onClick={() => {
                dispatch({
                  type: SET_CURRENT_ATTACHED_LEVEL_DATA,
                  data: {
                    currentAttachedLevelId: props.attachedLevelId,
                    currentAttachedLevelName: props.attachedLevelName,
                  },
                });
              
                dispatch({
                  type: SET_USER_TASK_POPUP_MODE,
                  data: { userTaskPopupMode: USER_TASK_POPUP_MODE.ADD },
                });
              
                const initialTaskData = {
                  statusId: defaultStatusValue,
                  assignedToUserId: null,
                  externalNotes: "",
                  notificationId: 0,
                };
              
                dispatch({
                  type: SET_USER_TASK_FORM_DATA,
                  data: {
                    userTaskFormData: cloneDeep({
                      statusId: defaultStatusValue,
                    }),
                    initialTaskData,
                  },
                });
                dispatch({
                  type: SET_ASSIGNED_USER_TYPE,
                  data: {
                    assignedUserType: null,
                  },
                });
              
                resetAddTaskPopupValidation(dispatch);
              
                dispatch(
                  actions.asyncOperationStart(GET_USER_TASK_DATASOURCE, {
                    attachedLevelId: props.attachedLevelId,
                    attachedLevelName: props.attachedLevelName,
                    attachedLevel: props.attachedLevelName,
                  })
                );
              
                asyncAction.asyncOperationStart(GET_ATTACHMENT_LEVEL_LIST, {});
              
                let title = "Add New Task";
                if (props.attachedLevelTitleName) {
                  title += " - " + props.attachedLevelTitleName;
                }
              
                toggleUserTaskPopup(dispatch, true, title, USER_TASK_POPUP_MODE.ADD);
              }
            }
            ></MdaeAddButton>
            {(currentUserActionMode === USER_ACTION_MODE.MULTIPLE_SELECT &&
              hasEditAccess &&
              props.isUserTaskBulkOptionVisible)
            &&(
            <TaskSelectionCounter />
            )}
            <MdaeButton
              id={"btnBulkAction"}
              role={"dxButton"}
              visible={Boolean(
                hasEditAccess && props.isUserTaskBulkOptionVisible
              )}
              stylingMode={"text"}
              className="data-grid-toolbar-button"
              elementAttr={{
                title: "Bulk Action",
              }}
              onContentReady={(e) => {
                $(e.component.element())
                  .find(".dx-button-content")
                  .addClass(
                    "bulk-action-button-content application-section-primary-background-color"
                  );
              }}
              onClick={handleBulkActionsClick}
            >
              Bulk Actions
            </MdaeButton>
          </>
        )}
        <MdaeButton
          id={"btnBulkDeleteTask"}
          role={"dxButton"}
          icon="dx-icon delete-action-icon"
          className="data-grid-toolbar-button"
          visible={Boolean(
            hasEditAccess &&
              hasBulkEditAccess &&
              ((currentUserActionMode === USER_ACTION_MODE.MULTIPLE_SELECT &&
                !currentUser?.isTaskHQAccessEnabled) ||
                props.isFromMyTaskPage)
          )}
          disabled={
            currentUserActionMode ===
            USER_ACTION_MODE.MY_TASK_EDIT_MULTIPLE_SELECT
          }
          text={""}
          elementAttr={{
            title: "Delete Multiple Tasks",
          }}
          onClick={onClickDeleteMultipleTasks}
        ></MdaeButton>
        <MdaeButton
          id={"btnBulkEditTask"}
          role={"dxButton"}
          icon="dx-icon edit-action-icon"
          className="data-grid-toolbar-button"
          visible={Boolean(
            hasEditAccess &&
              (currentUserActionMode === USER_ACTION_MODE.MULTIPLE_SELECT ||
                (props.isFromMyTaskPage && hasBulkEditAccess))
          )}
          disabled={
            currentUserActionMode ===
            USER_ACTION_MODE.MY_TASK_DELETE_MULTIPLE_SELECT
          }
          text={""}
          elementAttr={{
            title: "Edit Multiple Tasks",
          }}
          onClick={onClickBulkTaskEdit}
        ></MdaeButton>
        {!props.isFromMyTaskPage && (
          <MdaeButton
            id={"btnBulkReassignTask"}
            role={"dxButton"}
            icon="dx-icon fas fa-paper-plane application-section-primary-color"
            className="data-grid-toolbar-button"
            visible={Boolean(
              currentUserActionMode === USER_ACTION_MODE.MULTIPLE_SELECT &&
                !currentUser?.isTaskHQAccessEnabled
            )}
            text={""}
            elementAttr={{
              title: "Reassign Multiple Tasks",
            }}
            onClick={onReassignClick}
          ></MdaeButton>
        )}
      </div>
    );
  };
  const handleSelectionChanged = useCallback((e: any) => {
    dispatch({
      type: SET_USER_TASK_SELECTED_COUNT,
      data: {
        selectedTasksCount:e.selectedRowKeys?.length,
      },
    });  }, []);
  
  return (
    <div className={!props.isFromMyTaskPage && "page-container-padding"}>
      {props.isUserTaskChartVisible && <UserTaskChart dataGridInstance = {userTaskDataGridInstance}/>}
      <MdaeActionPopover
        mdaePopoverConfig={{
          id: "pnlUserTaskGridPopover",
          mdaeDataUpdaterConfig: [
            {
              actionType: TOGGLE_USER_TASK_LIST_POPOVER,
              reducerName: "userTaskListReducer",
              widgetOptionBindings: {
                target: "userTaskListDataGridActionPopoverTarget" + (taskDataPrefix ?? ""),
                visible: "isUserTaskListDataGridActionPopoverVisible" + (taskDataPrefix ?? ""),
              },
            },
          ],
        }}
        menuItemListFunction={actionPopoverMenuList}
      ></MdaeActionPopover>
      <MdaeDataGrid
        key={props.attachedLevelName}
        {...userTaskListDataGridOptions}
        onSelectionChanged={handleSelectionChanged}
        mdaeDataGridCustomButtons={!props.isToolBarNotVisible ? renderToolbarButtonTemplate : undefined}
        ></MdaeDataGrid>
      {!(props.isFromAuditView || props.isFromMyTaskPage) && props.caseData == null && !isCaseDetailPopupVisible && (
        <AddUserTaskPopup
          toggleUserTaskPopup={toggleUserTaskPopup}
          auditGroupId={props.auditGroupId}
          isFromUserTaskList={true}
          isFromMyTaskPage={props.isFromMyTaskPage}
          isExternalUser={props.isExternalUser}
          isManagerView={props.isManagerView}
          attachedLevelId={props.attachedLevelId}
          attachedLevelName={props.attachedLevelName}
          refreshUserTaskListFunction={props.isManagerView ? refreshTaskHqUserTaskListFunction: undefined}
        ></AddUserTaskPopup>
      )}

      <BulkEditUserTaskPopup
        toggleBulkEditUserTaskPopup={toggleBulkEditUserTaskPopup}
        refreshUserTaskListFunction={props.isManagerView ? refreshTaskHqUserTaskListFunction: props.refreshUserTaskListFunction}
        toggleUserTaskGridCheckboxesForMyTask={
          toggleUserTaskGridCheckboxesForMyTask
        }
        isManagerView={props.isManagerView}
      ></BulkEditUserTaskPopup>
      <CancelUpdatedTaskToast
        isManagerView={props.isManagerView}
        attachedLevelName={props.attachedLevelName}
        isExternalUser={props.isExternalUser}
        toggleUserTaskPopup={toggleUserTaskPopup}
        refreshUserTaskListFunction={props.isManagerView ? refreshTaskHqUserTaskListFunction: props.refreshUserTaskListFunction}
        isVisible={isCompleteTaskToastVisible}
      ></CancelUpdatedTaskToast>
    </div>
  );
};
const getUserTaskListDataGridOptions = (
  toggleActionPopover,
  onUserTaskListGridInstance,
  currentUserId,
  onUserTaskEditClick,
  callOperation,
  dispatch,
  isUserTaskChartVisible,
  isFilterValueChange,
  userTaskChartSelectedIndex,
  excelExportFileName,
  myTaskWidgetId,
  currentAttachedLevelName,
  currentAttachedLevelId,
  isManagerView,
  isFromMyTaskPage,
  myTasksPageOptions,
  setSearchText,
  userTaskListStateStoringKey,
  refreshUserTaskListFunction,
  userTaskListDataSource,
  isUserTaskListGridSetFiltered,
  currentUserActionMode,
  isInCompleteTaskCountClick,
  userTaskStatusList,
  isExternalUser,
  isCompleteTaskToastVisible,
  openTaskTabFromUrl,
  attachLevelEnums,
  isMaintenanceTask,
  isGetGridSettingCalled,
  TASK_HQ_PAGE_DATAGRID_STATE_STORAGE_KEYS,
  hasAuditViewAccess,
  isToolBarNotVisible,
  taskDataPrefix,
  attachedlevelId,
  taskHqDataSource
) => {
  const isCurrentPageMyTask = isFromMyTaskPage;
  const isCurrentPageTaskHQ = isManagerView;
  const cellRenderForNATypeColumns = (cellData) => {
    return cellData.value ? (
      <div title={cellData.value}>{cellData.value}</div>
    ) : (
      <>N/A</>
    );
  };
  const myTaskOrTaskHQColumns: IColumnProps[] = [
    {
      dataField: "linkedCaseId",
      caption: "Linked Case ID",
      cellRender: (cellData) => {
        if (cellData.data?.linkedCaseId) {
          let auditURLString = null;
          if (cellData.data.attachedLevel === "EAC") {
            auditURLString = `/externalaudit/audit?auditId=${cellData.data.auditId}&eacaseid=${cellData.data.linkedCaseId}`;
          } else if (cellData.data.attachedLevel === "AC") {
            auditURLString = `/audit/index/?auditId=${cellData.data.auditId}`;
          }
          if (hasAuditViewAccess && auditURLString) {
            return (
              <a href={auditURLString} target="_blank">
                {cellData.data.linkedCaseId ?? cellData.data.auditId}
              </a>
            );
          } else {
            return "N/A";
          }
        } else return "N/A";
      },
      width: 100,
    },
    {
      dataField: "submissionDeadlineDate",
      caption: "Current Round Submission Deadline",
      width: 100,
      cellRender: cellRenderForNATypeColumns,
    },
    {
      dataField: "rqstrOrganizationName",
      caption: "Requester",
      width: 160,
      cellRender: cellRenderForNATypeColumns,
    },
    {
      dataField: "patientLastName",
      caption: "Patient Last Name",
      width: 100,
      cellRender: cellRenderForNATypeColumns,
    },
    {
      dataField: "patientFirstName",
      caption: "Patient First Name",
      width: 100,
      cellRender: cellRenderForNATypeColumns,
    },
    {
      dataField: "payerRemitNo",
      caption: "Payer Remit #",
      width: 160,
      cellRender: cellRenderForNATypeColumns,
    },
    {
      dataField: "patientMRN",
      caption: "MRN",
      width: 100,
      cellRender: cellRenderForNATypeColumns,
    },
    {
      dataField: "billingProvider",
      caption: "Billing Provider",
      width: 100,
      cellRender: cellRenderForNATypeColumns,
    },
  ];

  let dataGridSuffix = currentAttachedLevelName;
  if(isManagerView){
    dataGridSuffix = "TaskHQPage";
  } else if(isFromMyTaskPage){
    dataGridSuffix = "MyTaskPage";
  }
  
  const userTaskDataGridOption: IMdaeDataGridProps = {
    id: "userTasksList" + dataGridSuffix,
    onInitialized: (e) => {
      onUserTaskListGridInstance(e);
    },
    remoteOperations :isManagerView ,
    mdaeColumnChooser: { isMdaeColumnChooserVisible: isToolBarNotVisible ? false:true },
    clearFilterButtonId:isToolBarNotVisible? "": "btn-user-task-list-grid-clear-filter",
    export: {
      fileName: excelExportFileName,
      enabled:isToolBarNotVisible?false: true,
      customizeExcelCell: function(options: any) {
        var gridCell = options.gridCell;
        if (!gridCell) {
          return;
        }
        if (
          gridCell.rowType === "data" &&
          gridCell.column.dataField === "scheduledDate"
        ) {
          if (options.value) {
            var updatedDate = new Date(options.value).setHours(0, 0, 0, 0);
            if (
              new Date(updatedDate).getTime() == new Date("1/1/1900").getTime()
            ) {
              (options as any).value = null;
            }
          }
        }
      },
    },
    headerFilter: {
      visible: isToolBarNotVisible ? false:true,
    },
    searchPanel: {
      visible: isToolBarNotVisible ? false : isUserTaskListSearchPanelVisible(
        isFromMyTaskPage,
        myTasksPageOptions
      ),
    },
    groupPanel: {
      visible: isUserTaskChartVisible,
    },
    grouping: {
      autoExpandAll: false,
    },
    filterRow: {
      visible:isToolBarNotVisible ?false: true,
    },
    filterPanel: {
      visible: isUserTaskChartVisible,
    },
    allowColumnReordering: true,
    allowColumnResizing: true,
    filterBuilderPopup: {
      width: 750,
      height: 400,
    },
    onDataGridClearFilterClick(e) {
      dispatch({
        type: SET_IS_INCOMPLETE_TASK_COUNT_CLICK,
        isInCompleteTaskCountClick: [0, false],
      });
    },
    onRowDblClick: function(e) {
      onUserTaskEditClick(e.data);
    },
    onCellPrepared: function(e) {
      if (e.rowType === "data") {
        var dateDue = e.data.dueDate
          ? new Date(e.data.dueDate).setHours(0, 0, 0, 0)
          : "";
        if (
          new Date(dateDue).getTime() <
            new Date(new Date().setHours(0, 0, 0, 0)).getTime() &&
          e.column.dataField == "dueDate" &&
          !e.data.completeInd
        ) {
          e.cellElement.style.color = "red";
        }
        if (
          e.data.assignedToUserId == currentUserId &&
          e.column.dataField == "assignedToUserName"
        ) {
          e.cellElement.style.fontWeight = "bold";
        }

        // to disable selection for required or commpleted tasks
        if (
          (e.column as any).command === "select" &&
          (e.data.requiredForAuditCompletionInd || e.data.completeInd) &&
          currentUserActionMode ===
            USER_ACTION_MODE.MY_TASK_DELETE_MULTIPLE_SELECT
        ) {
          var instance = CheckBox.getInstance(
            e.cellElement.querySelector(".dx-select-checkbox")
          );
          instance.option("visible", false);
          e.cellElement.style.pointerEvents = "none";
        }
      }
    },
    onSelectionChanged: (e) => {
      //to deselect required or commpleted tasks if user clicks select all
      if (
        currentUserActionMode ===
        USER_ACTION_MODE.MY_TASK_DELETE_MULTIPLE_SELECT
      ) {
        var disabledKeys = e.selectedRowsData.filter(
          (rowData) =>
            rowData.requiredForAuditCompletionInd || rowData.completeInd
        );
        if (disabledKeys.length > 0)
          e.component.deselectRows(
            disabledKeys.map((rowData) => rowData.userTaskId)
          );
      }
      if (e.selectedRowsData?.length > 0) {
        const isBulkTaskAssignedToGroup = e.selectedRowsData?.some(
          (rowData) =>
            rowData.assignedUserType == USER_TYPE.EG ||
            rowData.assignedUserType == USER_TYPE.TG
        );
        dispatch({
          type: SET_SELECTED_BULK_TASK_ASSIGNED_TO_GROUP,
          data: {
            isBulkTaskAssignedToGroup: isBulkTaskAssignedToGroup,
          },
        });
      } else {
        dispatch({
          type: SET_SELECTED_BULK_TASK_ASSIGNED_TO_GROUP,
          data: {
            isBulkTaskAssignedToGroup: false,
          },
        });
      }
    },
    mdaeStateStoring: {
      enabled: Boolean(userTaskListStateStoringKey) || isUserTaskChartVisible,
      storageKey: userTaskListStateStoringKey
        ? userTaskListStateStoringKey
        : userTaskChartSelectedIndex == 0
        ? TASK_HQ_PAGE_DATAGRID_STATE_STORAGE_KEYS.TASK_IN_FLIGHT_TAB
        : TASK_HQ_PAGE_DATAGRID_STATE_STORAGE_KEYS.TASK_PAST_DUE_TAB,
      isGetGridSettingCalled: isGetGridSettingCalled,
      isUserTaskDataGrid: true,
      onBeforeLoadGridState: (state) => {
        if (state?.selectedRowKeys?.length > 0) {
          state.selectedRowKeys = [];
        }
      },
    },
    onContentReady: (e) => {
      e.component.beginUpdate();
      const pagingObject = e.component.option("paging");
      if (pagingObject.pageSize === 0)
        //fix for bug - when user refereshes page while in multiple selection mode pageSize becomes 0
        e.component.option("paging", {
          enabled: true,
          pageSize: 20,
          pageIndex: 0,
        });
      if (e.component.option("selection").mode != "multiple") {
        e.component.clearSelection();
        e.component.columnOption("userTaskId", "visible", true);
        e.component.columnOption("completeInd", "visible", true);
      } else {
        e.component.columnOption("userTaskId", "visible", false);
        e.component.columnOption("completeInd", "visible", false);
      }

      const dataItems = e.component?.getDataSource();
      if (e.component.getCombinedFilter() != undefined && !isManagerView) {
        if (dataItems) {
          dataItems
            .store()
            .load({ filter: e.component.getCombinedFilter() })
            .then(function(filteredData) {
              dispatch({
                type: TOGGLE_FILTER_VALUE,
                data: { isFilterValueChange: false },
              });
              dispatch({
                type: SET_MY_TASK_WIDGET_DATASOURCE_FROM_TASK_LIST,
                data: {
                  myTaskWidgetId: myTaskWidgetId,
                  myTaskList: filteredData,
                },
              });
            });
        }
      } 
      if (
        e.component.getCombinedFilter() == undefined &&
        !isUserTaskChartVisible &&
        dataItems
      ) {
        dataItems
          .store()
          .load()
          .then(function(dataList) {
            dispatch({
              type: SET_MY_TASK_WIDGET_DATASOURCE_FROM_TASK_LIST,
              data: {
                myTaskWidgetId: myTaskWidgetId,
                myTaskList: dataList,
              },
            });
          });
      }
      if (
        e.component.getCombinedFilter() == undefined &&
        isInCompleteTaskCountClick[1] &&
        isInCompleteTaskCountClick[0] == currentAttachedLevelId
      ) {
        if (currentAttachedLevelName == "EAC") {
          var statusList = [];
          for (let i = 0; i < userTaskStatusList.length; i++) {
            if (
              userTaskStatusList[i]["statusCd"] != "Canceled" &&
              userTaskStatusList[i]["statusCd"] != "Completed"
            ) {
              statusList.push(userTaskStatusList[i]["statusCd"]);
            }
          }
          e.component.columnOption("status", "filterValues", statusList);
        }
      }
      if (currentAttachedLevelName?.toUpperCase() === "EAC") {
        const userTaskDataSource = e.component.getDataSource();
        userTaskDataSource
          ?.store()
          .load()
          .then(function(result: any[]) {
            let inCompleteTaskCount = result.filter(
              (x) => x.status != "Completed" && x.status != "Canceled"
            ).length;
            dispatch({
              type: UPDATE_CASE_DETAIL_LIST_DATA,
              data: {
                eaCaseId: currentAttachedLevelId,
                inCompleteTaskCount:
                  inCompleteTaskCount == 0 ? null : inCompleteTaskCount,
              },
            });
          });
      }
      if (isUserTaskListGridSetFiltered) {
        e.component &&
          e.component.columnOption(
            "requiredForAuditCompletionInd",
            "filterValues",
            [true]
          );
        e.component &&
          e.component.columnOption("completeInd", "filterValues", [false]);
        dispatch({
          type: SET_USER_TASK_GRID_FILTER,
          data: {
            isUserTaskListGridSetFiltered: false,
          },
        });
      }
      openTaskTabFromUrl(e);
      e.component.endUpdate();
    },
    onOptionChanged: (e) => {
      if (
        setSearchText &&
        e?.fullName === "searchPanel.text" &&
        e.value === ""
      ) {
        setSearchText("");
      }
    },
    mdaeColumns: [
      {
        fixed: true,
        allowSorting: false,
        allowFiltering: false,
        allowGrouping: false,
        allowResizing: false,
        allowReordering: false,
        allowHiding: false,
        allowExporting: false,
        alignment: "center",
        dataField: "userTaskId",
        caption: "",
        visible: true,
        cellRender: (e) => {
          return getDataGridActionEllipsisComponent(e, {
            showActionPopover: toggleActionPopover,
            entityName: excelExportFileName + "user-task-list",
            entityId: e.data.userTaskId + (attachedlevelId ?? ""),
            currentRowData: e.data,
            type: "usingDispatch",
            dispatch,
          });
        },
        width: 50,
      },
      {
        dataField: "completeInd",
        caption: "Complete",
        allowFiltering: true,
        allowSorting: true,
        fixed: true,
        allowHiding: false,
        visible: true,
        width: 120,
        cellRender: (cellData) => {
          let completedInd = cellData.displayValue;
          return (
            <MdaeCheckBox
              id="chkCompletedInd"
              defaultValue={completedInd}
              disabled={
                cellData.data.assignedUserType == USER_TYPE.EG ||
                cellData.data.assignedUserType == USER_TYPE.TG 
              }
              onValueChanged={function(e) {
                if (!cellData.data.completeInd) {
                  if (isExternalUser) {
                    if (isCompleteTaskToastVisible) {
                      dispatch({
                        type: TOGGLE_COMPLETE_TASK_TOAST,
                        data: {
                          isCompleteTaskToastVisible: false,
                        },
                      });
                    }
                    var initialTaskData = {
                      statusId: cellData.data.statusId,
                      assignedToUserId: cellData.data.assignedToUserId,
                      externalNotes: cellData.data.externalNotes,
                      notificationId: 0,
                    };
                    dispatch({
                      type: SET_USER_TASK_POPUP_OPENED_FROM_CARD_VIEW,
                      data: {
                        isOpenedFromCardView: false,
                        isMaintenanceLevelTask: isMaintenanceTask(
                          cellData.data,
                          attachLevelEnums
                        ),
                      },
                    });
                    quickCompleteTask(
                      dispatch,
                      cellData.data,
                      refreshUserTaskListFunction,
                      isManagerView,
                      currentAttachedLevelId,
                      currentAttachedLevelName,
                      true,
                      initialTaskData,
                      false
                    );
                    dispatch({
                      type: SET_USER_TASK_FORM_DATA,
                      data: {
                        initialTaskData: initialTaskData,
                      },
                    });
                    dispatch({
                      type: SET_GRID_COMPLETE_CHECKBOX_CLICKED,
                      data: {
                        isGridCompleteCheckboxClicked: true,
                        currentRowTaskData: cellData.data,
                      },
                    });
                  } else {
                    quickCompleteTask(
                      dispatch,
                      cellData.data,
                      refreshUserTaskListFunction,
                      isManagerView,
                      currentAttachedLevelId,
                      currentAttachedLevelName,
                      false,
                      initialTaskData,
                      false
                    );
                  }
                }
                e.component.option("value", true);
              }}
            />
          );
        },
      },
      {
        dataField: "refTaskName",
        caption: "Task",
        allowFiltering: true,
        allowSorting: true,
        fixed: true,
        width: 280,
        sortOrder: isFromMyTaskPage ? "asc" : undefined,
        sortIndex: 2,
      },
      {
        dataField: "status",
        caption: "Task Status",
        allowFiltering: true,
        allowSorting: true,
        width: 130,
      },
      {
        dataField: "auditId",
        caption: "Audit ID",
        cellRender: (cellData) => {
          if (cellData.data?.auditId) {
            const externalAuditLevels = ["EA", "EAC"];
            const auditURLString = externalAuditLevels.includes(
              cellData.data.attachedLevel
            )
              ? "/externalaudit/audit?auditId="
              : "/audit/index/?auditId=";
            if (hasAuditViewAccess) {
              return (
                <a
                  href={auditURLString + cellData.data.auditId}
                  target="_blank"
                >
                  {cellData.data.auditId}
                </a>
              );
            } else {
              return <>{cellData.data.auditId}</>;
            }
          } else return "N/A";
        },
        width: 100,
      },
      {
        dataField: "attachedLevelStatus",
        caption: "Linked Item Status",
        width: 130,
      },
      {
        dataField: "auditStatus",
        caption: "Audit Status",
        width: 130,
      },
      {
        dataField: "statusType",
        caption: "Status Type",
        allowFiltering: true,
        allowSorting: true,
        width: 130,
        sortOrder: isFromMyTaskPage ? undefined : "desc",
        sortIndex: 1,
        visible: false,
        showInColumnChooser: false,
        calculateSortValue: isManagerView ? undefined :function(rowData) {
          if (rowData.status == "Canceled" || rowData.status == "Completed")
            return this.sortOrder == "desc" ? "aaa" : "zzz";
          else return rowData.status;
        },
      },
      {
        dataField: "assignedToUserName",
        caption: "Assigned To",
        allowFiltering: true,
        allowSorting: true,
        width: 160,
        cellRender: (e) => {
          const { userName, externalUserGroupName } = getUserNameObject(
            e.data,
            isManagerView
          );
          if (externalUserGroupName) {
            return getExternalUserNameUI(externalUserGroupName, userName);
          }
          return <div title={userName}>{userName}</div>;
        },
        calculateCellValue: (cellData) => {
          const { userName, externalUserGroupName } = getUserNameObject(
            cellData,
            isManagerView
          );
          if (externalUserGroupName) {
            return `${userName} (${externalUserGroupName})`;
          }
          return userName;
        },
      },
      {
        dataField: "assignedToUserId",
        caption: "Assigned To UserId",
        allowFiltering: true,
        allowSorting: true,
        visible: false,
        showInColumnChooser: false,
        width: 160,
      },
      {
        dataField: "attachedLevelDisplayName",
        caption: "Level",
        allowFiltering: true,
        allowSorting: true,
        visible: false,
        width: 120,
      },
      {
        dataField: "levelName",
        caption: "Level Name",
        allowFiltering: true,
        allowSorting: true,
        width: 220,
      },
      {
        dataField: "round",
        caption: "Round",
        visible: !isManagerView,
        allowSearch:!isManagerView,
        showInColumnChooser: !isManagerView,
        allowFiltering: true,
        allowSorting: true,
        width: 110,
      },
      {
        dataField: "requiredForAuditCompletionInd",
        caption: "Required",
        allowFiltering: true,
        allowSorting: false,
        allowEditing: false,
        allowGrouping: false,
        visible: !isManagerView,
        allowSearch:!isManagerView,
        dataType: "boolean",
        falseText: "No",
        trueText: "Yes",
        width: 120,
      },
      {
        dataField: "dueDate",
        caption: "Due Date",
        dataType: "date",
        format: "MM/dd/yyyy",
        allowFiltering: true,
        allowSorting: true,
        width: 130,
        sortOrder: "asc",
        sortIndex: isFromMyTaskPage ? 1 : 2,
      },
      {
        dataField: "scheduledDate",
        caption: "Rescheduled Date",
        dataType: "date",
        format: "MM/dd/yyyy",
        allowFiltering: true,
        allowSorting: true,
        width: 130,
        cellRender: (cellData) => {
          var scheduleDate = format(cellData.value, "MM/DD/YYYY");
          if (
            new Date(scheduleDate).getTime() !=
              new Date("1/1/1900").getTime() &&
            cellData.value
          )
            return <div>{scheduleDate}</div>;
        },
      },
      {
        dataField: "completionDate",
        caption: "Completed Date",
        dataType: "date",
        format: "MM/dd/yyyy",
        allowFiltering: true,
        allowSorting: true,
        width: 130,
      },
      {
        dataField: "completedBy",
        caption: "Completed By",
        allowFiltering: true,
        allowSorting: true,
        width: 160,
      },
      {
        dataField: "taskCategoryName",
        caption: "Category",
        allowFiltering: true,
        allowSorting: true,
        width: 180,
      },
      {
        dataField: "taskCategoryType",
        caption: "Category Type",
        allowFiltering: true,
        allowSorting: true,
        visible: false,
        width: 180,
      },
      {
        dataField: "requiredTaskNote",
        caption: "Last Note",
        width: 180,
        cellRender: (data) => {
          return (
            <span
              title={data.value}
              className="display-task-last-note"
              onClick={() => onUserTaskEditClick(data.data, 0)}
            >
              {data.value}
            </span>
          );
        },
      },
      {
        dataField: "auditTitle",
        caption: "Audit",
        visible: false,
        width: 180,
      },
      {
        dataField: "entityTitle",
        caption: "Entity",
        visible: false,
        width: 180,
      },
      {
        dataField: "updatedBy",
        caption: "Updated by",
        allowFiltering: true,
        allowSorting: true,
        visible: false,
        width: 160,
      },
      {
        dataField: "updateDate",
        caption: "Updated on",
        dataType: "date",
        format: "MM/dd/yyyy",
        visible: false,
        allowFiltering: true,
        allowSorting: true,
        width: 110,
      },
      {
        dataField: "attachedDocumentCount",
        caption: "Documents",
        allowFiltering: true,
        allowSorting: true,
        width: 100,
        visible: !isManagerView,
        allowSearch:!isManagerView,
        showInColumnChooser: !isManagerView,
        cellRender: (data) => {
          return (
            <span
              title={data.value}
              className="display-attached-documents-count"
              onClick={() => onUserTaskEditClick(data.data, 1)}
            >
              {data.value}
            </span>
          );
        },
      },
      ...(isCurrentPageMyTask || isCurrentPageTaskHQ
        ? myTaskOrTaskHQColumns
        : ([] as any)),
    ],
    mdaeDataUpdaterConfig: [
      {
        actionType: getActionTypeForUserTasksDataGrid(
          isFromMyTaskPage,
          myTasksPageOptions
        ),
        reducerName: "userTaskListReducer",
        widgetOptionBindings: {
          dataSource: isFromMyTaskPage ? "myTaskList" : "userTaskList" + (taskDataPrefix ?? ""),
        },
        dataSourceOptions: {
          storeOptions: {
            key: "userTaskId",
          },
        },
      },
      {
        actionType: SET_USER_TASK_GRID_CHECKBOXES,
        reducerName: "userTaskListReducer",
        widgetOptionBindings: {
          selection: "userTaskGridSelection",
        },
      },
      
    ],
  };
  if(isManagerView){
    userTaskDataGridOption.mdaeDataUpdaterConfig.splice(0, 1);
    userTaskDataGridOption.dataSource = taskHqDataSource;
    userTaskDataGridOption.keyExpr = "userTaskId";

  }
  //remove updater if datasource is provided from props
  else if (userTaskListDataSource !== undefined) {
    userTaskDataGridOption.mdaeDataUpdaterConfig.splice(0, 1);
    userTaskDataGridOption.dataSource = userTaskListDataSource;
    userTaskDataGridOption.keyExpr = "userTaskId";
  }
  return userTaskDataGridOption;
};
const getActionTypeForUserTasksDataGrid = (
  isFromMyTaskPage,
  myTasksPageOptions
): string => {
   if (isFromMyTaskPage) {
    switch (myTasksPageOptions.myTasksPageTabName) {
      case MY_TASK_PAGE_TABS.COMPLETED_AND_CANCELED_TASKS_TAB:
        return GET_COMPLETED_AND_CANCELED_MY_TASKS;
      case MY_TASK_PAGE_TABS.ACTIVE_TASKS_TAB:
        return GET_MY_TASK_LIST;
    }
  } else return GET_USER_TASK_LIST_BY_LEVEL;
};
const isUserTaskListSearchPanelVisible = (
  isFromMyTaskPage,
  myTasksPageOptions
) => {
  if (
    isFromMyTaskPage &&
    myTasksPageOptions.myTasksPageTabName ===
      MY_TASK_PAGE_TABS.COMPLETED_AND_CANCELED_TASKS_TAB
  )
    return false;
  else return true;
};
const getUserNameObject = (cellData, isManagerView) => {
  let userName = cellData?.assignedToUserName;
  let externalUserGroupName = cellData?.externalUserGroupName;
  let isAssignedToExternalUser = cellData?.isAssignedToExternalUser;
  let result = { userName, externalUserGroupName };

  if (isAssignedToExternalUser && !isManagerView) {
    result.userName = userName + " (External User)";
    result.externalUserGroupName = null;
  }
  return result;
};
const getExternalUserNameUI = (externalUserGroupName, userName) => {
  return (
    <div title={userName + ` (` + externalUserGroupName + `)`}>
      {externalUserGroupName === "" ? (
        userName
      ) : externalUserGroupName?.toLowerCase() == "external" ? (
        <span>
          {userName} <i>({externalUserGroupName})</i>
        </span>
      ) : (
        userName + ` (` + externalUserGroupName + `)`
      )}
    </div>
  );
};
export default UserTaskList;
